module.exports = __webpack_public_path__ + "static/img/P-1-banner.43ea18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/P-1-banner.png
// module id = fq9F
// module chunks = 1